import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Add global error handler for script errors
window.addEventListener('error', (event) => {
  const errorDetails = {
    message: event.message,
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
    error: event.error,
    stack: event.error?.stack,
    userAgent: navigator.userAgent,
    url: window.location.href,
    timestamp: new Date().toISOString()
  };
  
  console.error('Global script error:', errorDetails);
  
  // Check if this is an authentication-related error
  const isAuthError = errorDetails.filename?.includes('auth.service') || 
                     errorDetails.message?.toLowerCase().includes('auth') ||
                     errorDetails.message?.toLowerCase().includes('user');
  
  if (isAuthError) {
    console.error('Authentication-related script error detected:', errorDetails);
  }
  
  // Report to Raygun if available and in production
  if (window.location.hostname === environment.config.site_uri && (window as any).rg4js) {
    try {
      (window as any).rg4js('send', {
        error: event.error || new Error(event.message),
        customData: {
          ...errorDetails,
          type: 'global-script-error',
          isAuthError: isAuthError
        }
      });
    } catch (e) {
      console.error('Failed to report global error to Raygun:', e);
    }
  }
});

// Handle unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  const rejectionDetails = {
    reason: event.reason,
    promise: event.promise,
    userAgent: navigator.userAgent,
    url: window.location.href,
    timestamp: new Date().toISOString()
  };
  
  console.error('Unhandled promise rejection:', rejectionDetails);
  
  // Check if this is an authentication-related promise rejection
  const isAuthRejection = typeof event.reason === 'string' && 
                         (event.reason.toLowerCase().includes('auth') || 
                          event.reason.toLowerCase().includes('user') ||
                          event.reason.toLowerCase().includes('firestore'));
  
  if (isAuthRejection) {
    console.error('Authentication-related promise rejection detected:', rejectionDetails);
  }
  
  if (window.location.hostname === environment.config.site_uri && (window as any).rg4js) {
    try {
      (window as any).rg4js('send', {
        error: event.reason,
        customData: {
          ...rejectionDetails,
          type: 'unhandled-promise-rejection',
          isAuthRejection: isAuthRejection
        }
      });
    } catch (e) {
      console.error('Failed to report promise rejection to Raygun:', e);
    }
  }
});

if (environment.production) {
  enableProdMode();
  if (window) {
    window.console.log = function () {};
  }
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));
